
export function StatCard({
  label,
  value,
  subtitle,
  accent,
  onClick,
  active,
}: {
  label: string;
  value: string | number;
  subtitle?: string;
  accent?: 'error' | 'warning';
  onClick?: () => void;
  active?: boolean;
}) {
  const base = accent === 'error' ? 'border-border-red-light bg-bg-red-light' : accent === 'warning' ? 'border-tangerine-300 bg-tangerine-50' : 'border-border-secondary bg-bg-raised';
  const ring = active ? 'ring-2 ring-blueberry-400' : '';
  const cursor = onClick ? 'cursor-pointer hover:shadow-md transition-shadow' : '';
  return (
    <div className={`rounded-lg border ${base} ${ring} ${cursor} p-4 shadow-sm`} onClick={onClick}>
      <div className="flex items-baseline gap-1.5">
        <div className="text-2xl font-semibold">{value}</div>
        {subtitle && <div className="text-[10px] text-icon-subtle">{subtitle}</div>}
      </div>
      <div className="text-xs text-icon-subtle uppercase">{label}</div>
    </div>
  );
}
